export const LOCALE_BCP47: Record<string, string> = {
  nl: "nl-NL",
  de: "de-DE",
  en: "en-GB",
  fr: "fr-FR",
  es: "es-ES",
  it: "it-IT",
};

export const LOCALE_OG: Record<string, string> = {
  nl: "nl_NL",
  de: "de_DE",
  en: "en_GB",
  fr: "fr_FR",
  es: "es_ES",
  it: "it_IT",
};

export function toBcp47(locale: string): string {
  return LOCALE_BCP47[locale] ?? locale;
}

export function toOgLocale(locale: string): string {
  return LOCALE_OG[locale] ?? locale.replace("-", "_");
}
